import React from "react";
import TableComponent from "../../generic-components/data-table/TableComponent";
import { useTranslation } from "@me8eon/translation";
import tableHeaderLabel from "../../../pages/service-request/tableHeaderLabel.json";
import TypingEffect from "../utils/typing-effect/TypingEffect";
import { ThemedIcon } from "@me8eon/icons";
import { MessageWithActionAndData } from "@me8eon/sessions_messages";

const serviceTableFields = ["number", "description", "state"];
type TableLabelData = {
    [lang: string]: {
        [key: string]: string;
    };
};

const tableHeaderData: TableLabelData = tableHeaderLabel;

const showIncidentsOrOrders: React.FC<MessageWithActionAndData> = ({
    data,
    content,
}) => {
    const { i18n } = useTranslation();
    const language = i18n.language;

    return (
        <div className="bot-header">
            <div className="eon-logo">
                <ThemedIcon name={"AiIcon"} />
            </div>
            <div className="bot-reply-container">
                <TypingEffect className="bot-text" text={content} speed={1} />
                {data && (
                    <TableComponent
                        showPagination={false}
                        rows={data}
                        cols={serviceTableFields.map(
                            (field) => tableHeaderData[language][field]
                        )}
                        headerMaps={serviceTableFields}
                    />
                )}
            </div>
        </div>
    );
};

export default showIncidentsOrOrders;
